import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as echarts from 'echarts';
let default_1 = class default_1 extends Vue {
    option;
    echartKey;
    isOnResize; // 是否监听window resize时自适应容器的改变
    myEchart;
    mounted() {
        this.$nextTick(() => {
            this.initEchart();
        });
        this.isOnResize && window.addEventListener('resize', this.initEchart);
    }
    async drawText() {
        // 解决初次渲染时自定义字体显示异常问题
        const font = '10px Bebas Neue';
        await document.fonts?.load(font);
    }
    async initEchart() {
        await this.drawText();
        const refName = 'echart-' + this.echartKey;
        if (!this.myEchart) {
            this.myEchart = echarts.init(this.$refs[refName]);
        }
        this.myEchart.clear();
        this.myEchart.resize();
        this.myEchart.setOption(this.option, true);
    }
    beforeDestroy() {
        if (this.myEchart) {
            this.myEchart.dispose();
        }
        this.isOnResize && window.removeEventListener('resize', this.initEchart);
    }
    onOptionChange(nv) {
        if (!nv)
            return;
        this.initEchart();
    }
};
__decorate([
    Prop()
], default_1.prototype, "option", void 0);
__decorate([
    Prop()
], default_1.prototype, "echartKey", void 0);
__decorate([
    Prop()
], default_1.prototype, "isOnResize", void 0);
__decorate([
    Watch('option', { immediate: false, deep: true })
], default_1.prototype, "onOptionChange", null);
default_1 = __decorate([
    Component({
        name: 'echartComponent',
    })
], default_1);
export default default_1;
